import React from 'react';
import Icon from '../../../components/AppIcon';

const IntensitySlider = ({ label, value, onChange, icon, min = 0, max = 100 }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name={icon} size={18} className="text-text-secondary" />
          <label className="text-sm font-medium text-text-primary">
            {label}
          </label>
        </div>
        <span className="text-sm font-semibold text-primary">
          {value}%
        </span>
      </div>
      <div className="relative">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={(e) => onChange(parseInt(e?.target?.value))}
          className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-5
            [&::-webkit-slider-thumb]:h-5
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-primary
            [&::-webkit-slider-thumb]:cursor-pointer
            [&::-webkit-slider-thumb]:shadow-md
            [&::-webkit-slider-thumb]:transition-all
            [&::-webkit-slider-thumb]:hover:scale-110
            [&::-moz-range-thumb]:w-5
            [&::-moz-range-thumb]:h-5
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-primary
            [&::-moz-range-thumb]:cursor-pointer
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:shadow-md
            [&::-moz-range-thumb]:transition-all
            [&::-moz-range-thumb]:hover:scale-110"
          style={{
            background: `linear-gradient(to right, var(--color-primary) 0%, var(--color-primary) ${value}%, var(--color-muted) ${value}%, var(--color-muted) 100%)`
          }}
        />
      </div>
      <div className="flex justify-between text-xs text-text-secondary">
        <span>Light</span>
        <span>Heavy</span>
      </div>
    </div>
  );
};

export default IntensitySlider;